// src/components/button/Button.tsx

import React from 'react';
import './Button.scss';
import { Icon } from 'react-feather';
import { Spinner } from '../spinner/Spinner';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  label?: string;
  icon?: Icon;
  iconPosition?: 'start' | 'end';
  iconColor?: 'red' | 'green' | 'grey';
  iconFill?: boolean;
  iconSize?: number;
  buttonStyle?: 'regular' | 'action' | 'alert' | 'flush';
  isLoading?: boolean;
}

export function Button({
  label = undefined,
  icon = void 0,
  iconPosition = 'start',
  iconColor = void 0,
  iconFill = false,
  iconSize = 16,
  buttonStyle = 'regular',
  isLoading = false,
  ...rest
}: ButtonProps) {
  const StartIcon = iconPosition === 'start' ? icon : null;
  const EndIcon = iconPosition === 'end' ? icon : null;
  const classList = [];
  if (iconColor) {
    classList.push(`icon-${iconColor}`);
  }
  if (iconFill) {
    classList.push(`icon-fill`);
  }
  classList.push(`button-style-${buttonStyle}`);
  if (isLoading) {
    classList.push('loading');
  }

  const style = {
    '--icon-size': `${iconSize}px`
  } as React.CSSProperties;

  return (
    <button data-component="Button" className={classList.join(' ')} style={style} {...rest}>
      <div className='button-content'>
        {isLoading ? (
          <>
            <Spinner size={iconSize} />
            {label && <span className="label">{label}</span>}
          </>
        ) : (
          <>
            {StartIcon && (
              <span className="icon icon-start">
                <StartIcon />
              </span>
            )}
            {label && <span className="label">{label}</span>}
            {EndIcon && (
              <span className="icon icon-end">
                <EndIcon />
              </span>
            )}
          </>
        )}
      </div>
    </button>
  );
}
